import { render } from "./main_page.vue?vue&type=template&id=7fb8637a"
import script from "./main_page.vue?vue&type=script&lang=js"
export * from "./main_page.vue?vue&type=script&lang=js"

import "./main_page.vue?vue&type=style&index=0&id=7fb8637a&lang=stylus"

import exportComponent from "/Volumes/KINDSTON/Lokal Google Drive/PROJECT/TECHSS/techss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__